import  styles from "./FilterAlertsDesktop.module.scss";
import { useEffect, useRef, useState } from "react";
import { Card } from "@mui/material";
import MultiSelectInput from "components/MainApp/atoms/Forms/MultiSelectInput";
import DateRangePicker from "components/MainApp/atoms/Filters/DateRangePicker/DateRangePicker";
import DevicesActivationButton from "components/MainApp/organisms/DevicesActivationButton/DevicesActivationButton";
import FilterAlertsMobile from "../mobile/FilterAlertsMobile";
import i18n from "i18n";

const statusOptions = [
  { id: "ALARM", value: i18n.t("new.alert") },
  { id: "ATTEMPTED_THEFT", value: i18n.t("attempted.theft") },
  { id: "THEFT", value: i18n.t("theft") },
  { id: "FALSE_ALARM", value: i18n.t("false.alarm") }
];

const DEFAULT_FILTER = { id: "ALARM", value: i18n.t("new.alert") }

const FilterAlertsDesktop = ({ filters, devices }) => {
  const [selectDevices, setSelectDevices] = useState([]);
  const [selectStatus, setSelectStatus] = useState([DEFAULT_FILTER]);
  const [selectDateRange, setSelectDateRange] = useState(null);

  const [isSmallWidth, setIsSmallWidth] = useState(false);
  const cardRef = useRef(null);

  const handleChangeDevices = deviceSelected => {
    setSelectDevices(deviceSelected);
  };

  const handleChangeStatus = statusSelected => {
    setSelectStatus(statusSelected);
  };

  useEffect(() => {
    setSelectDevices(devices);
  }, [devices]);

  useEffect(() => {
    filters.receiveSelection({
      devices: selectDevices.map(device => device.id)
    }, "devices");
  }, [selectDevices]);

  useEffect(() => {
    filters.receiveSelection({
      status: selectStatus.map(status => status.id)
    }, "status");
  }, [selectStatus]);

  useEffect(() => {
    filters.receiveSelection({ dateRange: selectDateRange }, "dateRange");
  }, [selectDateRange]);

  useEffect(() => {
    const debounceResize = (callback, delay) => {
      let timeout;
      return () => {
        clearTimeout(timeout);
        timeout = setTimeout(callback, delay);
      };
    };

    const handleResize = debounceResize(() => {
      if (cardRef.current && cardRef.current.offsetWidth > 0) {
        setIsSmallWidth(cardRef.current.offsetWidth < 1155);
      }
    }, 1000);

    const resizeObserver = new ResizeObserver(handleResize);

    if (cardRef.current) {
      resizeObserver.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        resizeObserver.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <Card ref={cardRef} className={styles["filter-alerts-desktop"]}>
      {isSmallWidth ? (
        <div className={styles["filter-alerts-desktop__small"]}>
          <FilterAlertsMobile
            filters={filters}
            devices={devices}
            isTablet={isSmallWidth}
          />
          <h5>{i18n.t("filters")}</h5>
        </div>
      ) : (
        <>
          <MultiSelectInput
            items={devices}
            selected={selectDevices}
            label={i18n.t("devices")}
            handleChange={handleChangeDevices}
            classInput={styles["filter-alerts-desktop__input"]}
            classItems={styles["filter-alerts-desktop__item"]}
            enableSelectAll
          />
          <MultiSelectInput
            items={statusOptions}
            selected={selectStatus}
            label={i18n.t("states")}
            handleChange={handleChangeStatus}
            classInput={styles["filter-alerts-desktop__input"]}
            classItems={styles["filter-alerts-desktop__item"]}
            enableSelectAll
          />
          <DateRangePicker setSelectDateRange={setSelectDateRange} />
        </>
      )}
      <DevicesActivationButton devices={devices} />
    </Card>
  );
};

export default FilterAlertsDesktop;
